import React from "react"
import PropTypes from "prop-types"
import { translate } from "react-i18next"
import styled from "styled-components"
import SelectList from "./SelectList"

const DropdownArea = styled.div`
  margin-left: 2em;
  margin-right: 2em;
`

const HelpText = styled.small`
  display: block;
  color: #bbb;
  font-style: italic;
`

function SelectListWithLabel({
  label,
  data,
  t,
  onChange,
  initialSelection,
  selectedValue,
  helpText,
  sortAlphabetically,
}) {
  const onSelectChange = (e) => {
    onChange(e.target.value)
  }

  const formatDataFromApi = () => {
    let options = data.map((opt) => {
      return { ...opt, text: t(opt.label), id: opt.value }
    })

    if (sortAlphabetically) {
      options = options.sort((a, b) => a.text.localeCompare(b.text))
    }

    return options
  }

  return (
    <DropdownArea className="row form-group">
      <div className="col-lg-5 col-md-5">
        <span>{label}</span>
        {helpText && helpText.length > 0 && <HelpText>{helpText}</HelpText>}
      </div>
      <div className="col-lg-5 col-md-5">
        <SelectList
          onSelectChange={onSelectChange}
          data={formatDataFromApi()}
          initialSelection={initialSelection}
          selectedValue={selectedValue}
        />
      </div>
    </DropdownArea>
  )
}

SelectListWithLabel.propTypes = {
  label: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired
    })
  ).isRequired,
  t: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  selectedValue: PropTypes.number,
  initialSelection: PropTypes.shape({
    id: PropTypes.number.isRequired,
    text: PropTypes.string.isRequired,
    disabled: PropTypes.bool
  }),
  helpText: PropTypes.string,
  sortAlphabetically: PropTypes.bool
}

SelectListWithLabel.defaultProps = {
  initialSelection: null,
  selectedValue: null,
  sortAlphabetically: false
}

export default translate()(SelectListWithLabel)



// WEBPACK FOOTER //
// ./src/components/custom-report/SelectListWithLabel.jsx